import React from 'react';

export const FlagPLIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 800 500" // Standard 8:5 ratio
    {...props}
  >
    <rect width="800" height="500" fill="#DC143C" rx="2"/> {/* Red (bottom half) */}
    <rect width="800" height="250" fill="#FFFFFF" /> {/* White (top half) */}
    <rect width="800" height="500" fill="none" stroke="#6b7280" strokeOpacity="0.3" strokeWidth="1" rx="2"/>
  </svg>
);